<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6.85714" fill="white" />
    <path d="M16.4659 12.0001L7.53406 12.0001" stroke="currentColor" stroke-width="1.37143" />
    <path d="M12 7.53431L12 16.4662" stroke="currentColor" stroke-width="1.37143" />
  </svg>
</template>
